import { render, staticRenderFns } from "./VouchersBalance.vue?vue&type=template&id=09a1c748&"
import script from "./VouchersBalance.vue?vue&type=script&lang=js&"
export * from "./VouchersBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a1c748')) {
      api.createRecord('09a1c748', component.options)
    } else {
      api.reload('09a1c748', component.options)
    }
    module.hot.accept("./VouchersBalance.vue?vue&type=template&id=09a1c748&", function () {
      api.rerender('09a1c748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/VouchersBalance.vue"
export default component.exports